import React from "react";
import ExecutiveForm from "./ExecutiveForm";

export default function AddExecutive() {
    return (
        <ExecutiveForm type="ADD" />
    );
}
